import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      width: '60%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      '@media (max-width: 1025px)': {
        width: '100%'
      }
    },
    media: {
      width: '100px',
      cursor: 'pointer'
    },
    labels: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      width: '100%'
    },
    description: {
      display: 'flex',
      flexDirection: 'column',
      '& h2': {
        fontSize: '1.25rem',
        marginBottom: '5px',
        color: palette.text.primary
      },
      cursor: 'pointer'
    },
    carousel: {
      width: '100%',
      maxWidth: '240px'
    },
    price: {
      marginLeft: '10px',
      marginTop: '5px',
      color: palette.text.primary
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      marginRight: '20px'
    },
    image: {
      width: '100px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
